import React from "react";
import styled from "@emotion/styled";

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: scale(0.7);
  @keyframes spin {
    0% {
      opacity: 0.1;
    }

    30% {
      opacity: 1;
    }

    100% {
      opacity: 0.1;
    }
  }
`;

(props) => ({
  display: "flex",
  flexDirection: props.column && "column",
});
const Triangle = styled.div((props) => ({
  width: "0px",
  height: "0px",
  margin: "0px -8px",
  borderLeft: "16px solid transparent",
  borderRight: "16px solid transparent",
  borderBottom: "28.8px solid rgb(89, 167, 0)",
  animation: `1s ease ${props.animationDelay} infinite normal none running spin`,
  filter: "drop-shadow(rgba(89, 167, 0, 0.6) 0px 0px 24px)",
  transform: props.up ? "none" : "rotate(180deg)",
}));

const Row = styled.div`
  display: flex;
`;

const StyledContainer = styled.div((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  width: "100%",
  height: props.inline ? "default" : "100%",
}));

const GTCSpinner = (props) => {
  return (
    <StyledContainer inline={props.inline}>
      <SpinnerContainer>
        <Row>
          <Triangle up={true} animationDelay={"-1s"} />
          <Triangle up={false} animationDelay={"-0.944444s"} />
          <Triangle up={true} animationDelay={"-0.888889s"} />
        </Row>
        <Row>
          <Triangle up={true} animationDelay={"-1s"} />
          <Triangle up={false} animationDelay={"-0.944444s"} />
          <Triangle up={true} animationDelay={"-0.888889s"} />
          <Triangle up={false} animationDelay={"-0.833333s"} />
          <Triangle up={true} animationDelay={"-0.777778s"} />
        </Row>
        <Row>
          <Triangle up={true} animationDelay={"-0.0555556s"} />
          <Triangle up={false} animationDelay={"-0.111111s"} />
          <Triangle up={true} animationDelay={"-1s"} />
          <Triangle up={false} animationDelay={"-0.833333s"} />
          <Triangle up={true} animationDelay={"-0.666667s"} />
          <Triangle up={false} animationDelay={"-0.722222s"} />
          <Triangle up={true} animationDelay={"-0.666667s"} />
        </Row>
        <Row>
          <Triangle up={false} animationDelay={"-0.166667s"} />
          <Triangle up={true} animationDelay={"-0.222222s"} />
          <Triangle up={false} animationDelay={"-0.166667s"} />
          <Triangle up={true} animationDelay={"-0.333333s"} />
          <Triangle up={false} animationDelay={"-0.5s"} />
          <Triangle up={true} animationDelay={"-0.611111s"} />
          <Triangle up={false} animationDelay={"-0.555556s"} />
        </Row>
      </SpinnerContainer>
    </StyledContainer>
  );
};

export default GTCSpinner;
